<template>
    <div>
        <router-view />
    </div>
</template>
<script>

export default {
    name: "LumpsumIndex",
    data() {
        return {}
    },
    created() {

    },
    methods: {

    },
}

</script>